import {
  SignInPayload,
  SignUpPayload,
  VerifyCodePayload,
  TelegramAuthPayload,
  ForgetPasswordPayload,
  SendResetCodePayload,
  ResetPasswordPayload,
} from "src/types/api";
import {
  baseInstance,
  getRefreshToken,
  saveAccessToken,
  saveRefreshToken,
} from "src/api";

export const userLogout = async () => {
  try {
    return await baseInstance.post(
      "user/logout/",
      { refresh: getRefreshToken() },
      { skipAuthInterceptor: true } as any
    );
  } catch (err: any) {
    return err;
  }
};

export const signIn = async (payload: SignInPayload) => {
  try {
    const response = await baseInstance.post("user/login/", payload);
    const { access, refresh } = response.data;
    saveAccessToken(access);
    saveRefreshToken(refresh);
    return response;
  } catch (err: any) {
    return err;
  }
};

export const verifyCode = async (payload: VerifyCodePayload) => {
  try {
    return await baseInstance.post("user/check-confirm-code/", payload);
  } catch (err: any) {
    return err;
  }
};

export const signUpEmail = async (payload: SignUpPayload) => {
  try {
    return await baseInstance.post("user/registration/", payload);
  } catch (err: any) {
    return err;
  }
};

export const telegramAuth = async (payload: TelegramAuthPayload) => {
  try {
    return await baseInstance.post("user/auth/telegram/", payload);
  } catch (err: any) {
    return err;
  }
};

export const telegramWebAppAuth = async (initData: string) =>
  baseInstance.post(
    "user/auth/telegram-webapp/",
    { init_data: initData },
    { skipAuthInterceptor: true } as any
  );


export const forgetPassword = async (payload: ForgetPasswordPayload) => {
  try {
    return await baseInstance.post("user/send-confirm-code/", payload);
  } catch (err: any) {
    return err;
  }
};

export const sendResetCode = async (payload: SendResetCodePayload) => {
  try {
    return await baseInstance.post("user/check-reset-code/", payload);
  } catch (err: any) {
    return err;
  }
};

export const resetPassword = async (payload: ResetPasswordPayload) => {
  try {
    return await baseInstance.post("user/reset-password/", payload);
  } catch (err: any) {
    return err;
  }
};

